import { AxiosResponse } from 'axios';
import { IInquiriesOfAgent } from 'types/agentInquiries';
import AxiosInstance from './AxiosInstance';

export const getAgentInquiries = async (): Promise<AxiosResponse<IInquiriesOfAgent>> =>
  AxiosInstance.get('livechat/inquiries.queuedForUser');
